import React from "react";
import { Building2, Cable, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CompanySolutions = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 grid md:grid-cols-2 gap-8">
        {/* Our Company */}
        <div className="group relative overflow-hidden rounded-3xl p-10 border border-slate-100 bg-white hover:shadow-2xl hover:shadow-emerald-500/10 hover:-translate-y-1 transition-all duration-500">
          <div
            className="absolute -top-20 -right-20 w-64 h-64 rounded-full blur-3xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"
            style={{
              background:
                "radial-gradient(circle, #10b981 0%, transparent 70%)",
            }}
          />
          <div className="relative">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30"
              style={{
                background:
                  "linear-gradient(135deg, #10b981 0%, #059669 100%)",
              }}
            >
              <Building2 className="text-white" size={28} strokeWidth={2} />
            </div>
            <h2
              className="text-3xl md:text-4xl font-bold mb-5 tracking-tight"
              style={{ color: "#0a2e1f" }}
            >
              Our Company
            </h2>
            <p className="text-slate-600 leading-relaxed mb-8">
              <strong className="text-slate-800">D-H Gadiola</strong> can supply
              you with the right sizes, types, and quantities of product you
              need to keep you on schedule and your management happy. We have
              been doing this since 1999.
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-emerald-700 font-semibold text-sm hover:gap-3 transition-all"
            >
              Learn More <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        {/* Solutions */}
        <div className="group relative overflow-hidden rounded-3xl p-10 border border-slate-100 bg-white hover:shadow-2xl hover:shadow-emerald-500/10 hover:-translate-y-1 transition-all duration-500">
          <div
            className="absolute -top-20 -right-20 w-64 h-64 rounded-full blur-3xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"
            style={{
              background:
                "radial-gradient(circle, #34d399 0%, transparent 70%)",
            }}
          />
          <div className="relative">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30"
              style={{
                background:
                  "linear-gradient(135deg, #10b981 0%, #047857 100%)",
              }}
            >
              <Cable className="text-white" size={28} strokeWidth={2} />
            </div>
            <h2
              className="text-3xl md:text-4xl font-bold mb-5 tracking-tight"
              style={{ color: "#0a2e1f" }}
            >
              Solutions
            </h2>
            <p className="text-slate-600 leading-relaxed mb-8">
              <strong className="text-slate-800">
                If you need a non-stock item,
              </strong>{" "}
              don't worry. We will have it made for you. Custom cable and
              custom heat shrink shapes are another of our specialties — design,
              engineering and installation tailored to your exact requirements.
            </p>
            <Link
              to="/special-services"
              className="inline-flex items-center gap-2 text-emerald-700 font-semibold text-sm hover:gap-3 transition-all"
            >
              View Services <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanySolutions;
